import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

const HistoryTableHeader: FC = () => (
    <div className="bg-grey-50 border-divider min-h-5 border-b px-4 py-2">
        <div className="flex w-full flex-row justify-center gap-3">
            <span className="w-[40%] font-semibold">
                <FormattedMessage id="history.table-header.field-value" />
            </span>
            <span className="w-[26%] font-semibold">
                <FormattedMessage id="history.table-header.start-date" />
            </span>
            <span className="w-[26%] font-semibold">
                <FormattedMessage id="history.table-header.end-date" />
            </span>
            <span className="w-[10%]" />
        </div>
    </div>
);

export default HistoryTableHeader;
